import type { ReactNode } from 'react';

interface NickCosmetic {
  code: string;
  kind: string;
  asset: string;
  rarity: number;
}

/**
 * Ники Straddle Pass — CSS по «Никнеймы — описание.md»: цвет/градиент/эффект,
 * шрифт не меняется. Классы .nfx-* в theme.css; reduced-motion гасит анимации
 * там же. asset предмета = css-ключ (color_steel, gradient, neon, …).
 */
export function NickFx({
  cosmetic,
  children,
}: {
  cosmetic: NickCosmetic | null | undefined;
  children: ReactNode;
}) {
  if (!cosmetic || cosmetic.kind !== 'css') return <>{children}</>;
  return <span className={`nfx nfx-${cosmetic.asset}`}>{children}</span>;
}
